















































import { Vue, Component, Prop } from "vue-property-decorator";
import { Term as ITerm } from "@/api/models/term";
import { TermEdit as ITermEdit } from "@/api/models/term-edit";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";
@Component({
  components: { TableActions, CustomTableCol, CustomTableItem }
})
export default class TaxonomyProfessionalActivityItem extends Vue {
  @Prop() term!: ITerm;
  showEditDetail: boolean = false;
  title!: string;
  description?: string;
  isDeletingProcess: boolean = false;
  isFakeLoading: boolean = false;

  data() {
    return {
      title: undefined,
      description: undefined
    };
  }

  deleteTerm() {
    this.isDeletingProcess = true;
    this.$emit("deleteTerm", this.term.id);
  }

  checkForSave() {
    this.showEditDetail = true;
  }

  async applyChange() {
    this.isFakeLoading = true;
    setTimeout(() => {
      this.isFakeLoading = false;
    }, 1000);
    let params: ITermEdit = {
      title: this.title,
      description: this.description
    };
    this.$emit("update", { termId: this.term.id, params: params });
    this.showEditDetail = false;
  }

  created() {
    if (this.term) {
      this.title = this.term.title;
      this.description = this.term.description;
    }
  }
}
